import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
export var TooltipCategories = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 5px;\n  max-width: 200px;\n"], ["\n  margin-bottom: 5px;\n  max-width: 200px;\n"])));
var templateObject_1;
